import React from 'react';

const STALE_THRESHOLD_MIN = 30;

/** NEX-1183 항목6: last_synced_at 기반 "마지막 동기화 N분 전" 배지. 30분 초과 시 붉은 경고. */
export default function SyncFreshnessBadge({ lastSyncedAt, label = '마지막 동기화' }) {
  const normalized = lastSyncedAt?.replace(' ', 'T');
  const synced = normalized ? new Date(normalized + (/(Z|[+-]\d{2}:?\d{2})$/.test(normalized) ? '' : 'Z')) : null;
  if (!synced || Number.isNaN(synced.getTime())) {
    return (
      <span className="px-1.5 py-0.5 rounded bg-gray-700 text-gray-400" title="원천 관측 시각이 제공되지 않았습니다">
        동기화 시각 없음
      </span>
    );
  }

  const minutesAgo = Math.max(0, Math.round((Date.now() - synced.getTime()) / 60000));
  const isStale = minutesAgo > STALE_THRESHOLD_MIN;

  return (
    <span
      className={`px-1.5 py-0.5 rounded font-medium ${isStale ? 'bg-red-900/60 text-red-300' : 'bg-gray-700 text-gray-400'}`}
      title={synced.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' }) + ' KST'}
    >
      {label} {minutesAgo}분 전{isStale ? ' — 지연' : ''} · {synced.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' })} KST
    </span>
  );
}
